export const CopyIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M10 19H18V8H10V19ZM8 7.992C8 6.892 8.902 6 10.009 6H17.991C19.101 6 20 6.893 20 7.992V19.008C20 20.108 19.098 21 17.991 21H10.01C9.74722 21.0012 9.48679 20.9506 9.24356 20.8511C9.00034 20.7517 8.77908 20.6053 8.59244 20.4203C8.40579 20.2353 8.25741 20.0154 8.15576 19.7731C8.05411 19.5307 8.00118 19.2708 8 19.008V7.992Z"
                fill="currentColor"
            />
            <path
                d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15V16H5ZM7 16H15V5H7V16Z"
                fill="currentColor"
            />
        </svg>
    )
}
